import React from 'react'

// components
import PageWrapper from 'components/PageWrapper'
import MovementDetail from 'components/MovementDetail'

const MovementsViewDetail = () => (
  <PageWrapper noTabBar title='Movimientos' viewSelected='/movimientos'>
    <div className='mb-16'>
      <MovementDetail />
    </div>
  </PageWrapper>
)

export default MovementsViewDetail
